import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import TablePagination from "./TablePagination";
import { getUserLogs } from "../Apis/UserAPIs";

const UserLogLayer = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [activeTab, setActiveTab] = useState("Web");

    const fetchData = async () => {
        setLoading(true);
        try {
            let mappedUserType = "Admin";
            if (activeTab === "mobile-admin") {
                mappedUserType = "Manager";
            } else if (activeTab === "user app") {
                mappedUserType = "AppUser";
            }

            const params = {
                page: currentPage,
                limit: rowsPerPage,
                search: searchTerm,
                userType: mappedUserType
            };
            const res = await getUserLogs(params);
            if (res.status) {
                setData(res.response?.data || []);
                setTotalRecords(res.response?.total || 0);
                setTotalPages(res.response?.totalPages || 0);
            }
        } catch (error) {
            console.error("Error fetching user logs:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [currentPage, rowsPerPage, searchTerm, activeTab]);

    const handleTabChange = (tabName) => {
        setActiveTab(tabName);
        setCurrentPage(0);
        setSearchTerm("");
    };

    const handleRowsPerPageChange = (e) => {
        setRowsPerPage(parseInt(e.target.value));
        setCurrentPage(0);
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        });
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom py-12 px-24 d-flex align-items-center justify-content-between" style={{ background: "linear-gradient(135deg, #000000ff, #bb0007ff, #ff0000ff)" }}>
                <h6 className="text-white pb-2 mb-0">User Log</h6>
                <div className="d-flex align-items-center gap-3">
                    <form className="navbar-search" onSubmit={(e) => e.preventDefault()}>
                        <input
                            type="text"
                            className="bg-base h-40-px w-auto"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(0);
                            }}
                            style={{ color: "black" }}
                        />
                        <Icon icon="ion:search-outline" className="icon" style={{ color: "black" }} />
                    </form>
                </div>
            </div>
            <div className="card-body p-24">
                {/* 3 Tabs Implementation */}
                <div className="mb-20 border-bottom">
                    <ul className="nav bordered-tab d-inline-flex nav-pills mb-0" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${activeTab === "Web" ? "active" : ""}`}
                                type="button"
                                onClick={() => handleTabChange("Web")}
                            >
                                Web Log
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${activeTab === "mobile-admin" ? "active" : ""}`}
                                type="button"
                                onClick={() => handleTabChange("mobile-admin")}
                            >
                                Mobile Admin Log
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${activeTab === "user app" ? "active" : ""}`}
                                type="button"
                                onClick={() => handleTabChange("user app")}
                            >
                                Visitor App Log
                            </button>
                        </li>
                    </ul>
                </div>

                <div className="table-responsive">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr style={{ background: "linear-gradient(135deg, #bb0007, #ed1c24)" }}>
                                <th scope="col" style={{ color: "white", fontWeight: "bold" }}>S.No</th>
                                <th scope="col" style={{ color: "white", fontWeight: "bold" }}>User Name</th>
                                <th scope="col" style={{ color: "white", fontWeight: "bold" }}>{activeTab === "mobile-admin" ? "Location / Coordinates" : "Location"}</th>
                                {activeTab === "mobile-admin" && (
                                    <th scope="col" style={{ color: "white", fontWeight: "bold" }}>Location Status</th>
                                )}
                                <th scope="col" style={{ color: "white", fontWeight: "bold" }}>Login Time</th>
                                <th scope="col" style={{ color: "white", fontWeight: "bold" }}>Logout Time</th>
                                {activeTab === "mobile-admin" && (
                                    <th scope="col" style={{ color: "white", fontWeight: "bold" }}>Remarks</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={activeTab === "mobile-admin" ? 7 : 5} className="text-center py-40">
                                        <div className="spinner-border text-danger" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : data.length > 0 ? (
                                data.map((item, index) => (
                                    <tr key={index}>
                                        <td>{currentPage * rowsPerPage + index + 1}</td>
                                        <td>{item.userName}</td>
                                        <td>
                                            <div>{item.locationName || "N/A"}</div>
                                            {activeTab === "mobile-admin" && item.latitude && item.longitude && (
                                                <div className="text-xs text-muted" style={{ fontSize: '11px', marginTop: '2px' }}>
                                                    Lat: {item.latitude}, Lng: {item.longitude}
                                                </div>
                                            )}
                                        </td>
                                        {activeTab === "mobile-admin" && (
                                            <td>
                                                {item.status === 'Failed' ? (
                                                    <span className="badge bg-warning-focus text-warning-main px-12 py-4 radius-4 fw-medium text-xs">
                                                        N/A (Restricted)
                                                    </span>
                                                ) : item.isMissedLocation ? (
                                                    <span className="badge bg-danger-focus text-danger-main px-12 py-4 radius-4 fw-medium text-xs">
                                                        Missed Location
                                                    </span>
                                                ) : (
                                                    <span className="badge bg-success-focus text-success-main px-12 py-4 radius-4 fw-medium text-xs">
                                                        Within Range
                                                    </span>
                                                )}
                                            </td>
                                        )}
                                        <td>{formatDateTime(item.loginTime)}</td>
                                        <td>{formatDateTime(item.logoutTime)}</td>
                                        {activeTab === "mobile-admin" && (
                                            <td style={{ fontSize: '13px', maxWidth: '200px', wordBreak: 'break-word' }}>
                                                {item.remarks || "N/A"}
                                            </td>
                                        )}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={activeTab === "mobile-admin" ? 7 : 5} className="text-center py-40">
                                        <div className="text-secondary-light">No records found.</div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {totalRecords > 0 && (
                    <TablePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleRowsPerPageChange}
                        totalRecords={totalRecords}
                    />
                )}
            </div>
        </div>
    );
};

export default UserLogLayer;
